import { fillObject } from 'utils'

export enum BorrowerSeperator {
  BORROWER = 'borrower',
  CO_BORROWER = 'coBorrower',
  CO_BORROWER2 = 'coBorrower2',
  CO_BORROWER3 = 'coBorrower3',
  CO_BORROWER4 = 'coBorrower4',
  CO_BORROWER5 = 'coBorrower5',
  CO_BORROWER6 = 'coBorrower6',
  CO_BORROWER7 = 'coBorrower7',
}

export const BorrowerSeparatorList = Object.values(BorrowerSeperator)

export const CoBorrowers: Array<string> = BorrowerSeparatorList.filter((v) => v !== BorrowerSeperator.BORROWER)

export const BorrowerLabel: Record<string, string> = fillObject(
  BorrowerSeparatorList,
  (borrowerSep: any) => `Borrower ${BorrowerSeparatorList.indexOf(borrowerSep) + 1}`,
)
